import { Button, HStack, Text } from '@ayble-health/dashboard-components';
import { ChevronLeft, ChevronRight } from 'lucide-react';

type Props = {
  page: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onPageChange: (page: number) => void;
};

export const PaginationFooter = ({
  page,
  totalPages,
  hasNextPage,
  hasPreviousPage,
  onPageChange,
}: Props) => {
  // Single page, shows nothing
  if (!hasNextPage && !hasPreviousPage) return null;

  return (
    <HStack gap={4} alignItems={'center'} justifyContent={'center'} py={4}>
      <Button
        size={'sm'}
        variant={'outline'}
        disabled={!hasPreviousPage}
        onClick={() => onPageChange(page - 1)}
        aria-label="Previous page"
      >
        <ChevronLeft size={16} />
      </Button>

      <Text color={'secondary.500'} fontWeight={'medium'}>
        Page {page} of {totalPages}
      </Text>

      <Button
        size={'sm'}
        variant={'outline'}
        disabled={!hasNextPage}
        onClick={() => onPageChange(page + 1)}
        aria-label="Next page"
      >
        <ChevronRight size={16} />
      </Button>
    </HStack>
  );
};

export default PaginationFooter;
